import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';

import Grants from 'components/BKanatarciResearchGrants/Grants';
import { useEffect } from "react";

function ResearchGrants() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <>
    {isMobile ? ( 
      <>
        <MobileNavbar /> 
        <Grants/>
        <hr />
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <Grants/>
        <hr />
        <Footer />
      </>
    )}
    </>
  );
}

export default ResearchGrants;
